import React, { useState, useRef } from 'react'
import { Pencil } from 'lucide-react'

const Option = ({ option, onClick, isLast, selected, editing, onEdit, onSave }) => {
  const [editValue, setEditValue] = useState(option.name)
  const inputRef = useRef(null)
  const [hovered, setHovered] = useState(false)

  // Focus input when entering edit mode
  React.useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus()
    }
    if (!editing) {
      setEditValue(option.name)
    }
  }, [editing, option.name])

  const handleSave = () => {
    if (editValue.trim() && editValue !== option.name) {
      onSave(option.id, editValue.trim())
    }
    onEdit(null) // exit edit mode
  }

  if (editing) {
    return (
      <div className={`card ${isLast ? '' : 'mb-2'} ${selected ? 'border-primary bg-primary text-white' : ''}`}
        style={{ cursor: 'pointer' }}>
        <div className="card-body d-flex align-items-center">
          <input
            ref={inputRef}
            type="text"
            className="form-control form-control-sm"
            value={editValue}
            onChange={e => setEditValue(e.target.value)}
            onBlur={handleSave}
            onKeyDown={e => {
              if (e.key === 'Enter') handleSave()
              if (e.key === 'Escape') onEdit(null)
            }}
            style={{ maxWidth: '70%' }}
          />
        </div>
      </div>
    )
  }

  return (
    <div
      className={`card ${isLast ? '' : 'mb-2'} ${selected ? 'border-primary bg-primary text-white' : ''}`}
      onClick={onClick}
      style={{ cursor: 'pointer', position: 'relative' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="card-body d-flex align-items-center justify-content-between">
        <h5 className="card-title mb-0">{option.name}</h5>

        <button
          className="btn btn-outline-secondary btn-sm ms-2 option-edit-btn"
          style={{ zIndex: 2, opacity: hovered ? 1 : 0}}
          onClick={e => {
            e.stopPropagation();
            onEdit(option.id)
          }}
          tabIndex={0}
        >
          <Pencil />
        </button>
      </div>
      {option.description && (
        <div className="card-body pt-0 pb-2">
          <p className="card-text">{option.description}</p>
        </div>
      )}
    </div>
  )
}

export default Option
